import React, { useMemo } from 'react'
import ApiiroCredentialForm from './ApiiroCredentialForm';
import ApiiroMappingForm from './ApiiroMappingForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from 'utils/tableUtils';

export default function ApiiroConfigListing(props) {

    const columns = useMemo(() => [{
        title: "Application Name",
        dataIndex: "applicationName",
        render: columnRenderArrayData,
        width: 200
    },
    {
        title: "Repository",
        dataIndex: "repositoryName",
        render: columnRenderArrayData,
        width: 200
    },
    ], []);

    return (
        <GenericPullConfigListing
            {...props}
            extraColumns={columns}
            toolName={props.name}
            MappingForm={ApiiroMappingForm}
            CredentialsForm={ApiiroCredentialForm}
            displayComponentName="Application Name"
        />
    )
}